"use client";

import { lazy } from "react";
import type { ToolUIRegistry } from "../../tool-renderer";

export const sandboxToolRegistry = {
  bash: {
    kind: "step",
    category: "code",
    view: lazy(() =>
      import("./bash").then(({ BashToolView }) => ({
        default: BashToolView,
      }))
    ),
  },
  editFile: {
    kind: "step",
    category: "code",
    view: lazy(() =>
      import("./edit-file").then(({ EditFileToolView }) => ({
        default: EditFileToolView,
      }))
    ),
  },
  installPackages: {
    kind: "step",
    category: "code",
    view: lazy(() =>
      import("./install-packages").then(({ InstallPackagesToolView }) => ({
        default: InstallPackagesToolView,
      }))
    ),
  },
  multiEdit: {
    kind: "step",
    category: "code",
    view: lazy(() =>
      import("./multi-edit").then(({ MultiEditToolView }) => ({
        default: MultiEditToolView,
      }))
    ),
  },
  writeFile: {
    kind: "step",
    category: "code",
    view: lazy(() =>
      import("./write-file").then(({ WriteFileToolView }) => ({
        default: WriteFileToolView,
      }))
    ),
  },
  previewFile: {
    kind: "step",
    category: "code",
    view: lazy(() =>
      import("./preview-file").then(({ PreviewFileToolView }) => ({
        default: PreviewFileToolView,
      }))
    ),
  },
  presentFiles: {
    kind: "standalone",
    category: "code",
    view: lazy(() =>
      import("./present-files").then(({ PresentFilesToolView }) => ({
        default: PresentFilesToolView,
      }))
    ),
  },
} satisfies ToolUIRegistry;
